<template>
  <b-card class="rounded-xl">
    <modal :show.sync="ReviewModal" header-classes="bg-primary p-3" size="lg">
      <h6 slot="header" class="modal-title text-white font-semibold pt-1">
        Seller Review
      </h6>
      <ReviewTable />
      <template slot="footer">
        <base-button type="primary">SAVE CHANGES</base-button>
        <base-button
          type="secondary"
          class="ml-auto"
          @click="ReviewModal = false"
          >CLOSE</base-button
        >
      </template>
    </modal>
    <AddTagsSidebar
      :isSidebarActive="openAddBannerSidebar"
      @closeSidebar="toggleAddBannerSidebar"
    />
    <div class="flex  justify-between  items-center">
      <div>
        <h2 class="text-2xl font-semibold">
          Manage Seller Review
        </h2>

        <!-- <small class=" text-muted "
          >Lorem ipsum dolor sit amet, consectetur adipiscing elit,
        </small> -->
      </div>
      <!-- <base-button outline type="success" class="flex" @click="addBanner">
        <feather-icon icon="PlusIcon" class="mr-1"></feather-icon>Add Store
      </base-button> -->
    </div>
    <b-input-group class="mt-12">
      <b-form-input
        class="border-none shadow-lg"
        type="text"
        min="0.00"
        placeholder="Enter Search...."
      ></b-form-input>

      <b-input-group-append>
        <b-button
          variant="white"
          class="flex items-center shadow-lg"
          aria-label="search"
        >
          <feather-icon
            class=" cursor-pointer  mr-2"
            icon="SearchIcon"
            svgClasses="w-4 h-4"
          ></feather-icon>
        </b-button>
      </b-input-group-append>
    </b-input-group>
    <el-table
      class="table-responsive table-flush mt-6 cust-overflow-x-primary-color"
      header-row-class-name="thead-light table-th-color"
      :data="TagsData"
    >
      <el-table-column label="ID" prop="id" min-width="120px" sortable>
        <template v-slot="{ row }">
          <span class=" text-black font-medium">{{ row.id }}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="Store Name"
        min-width="180px"
        prop="storename"
        sortable
      >
        <template v-slot="{ row }">
          <span class=" text-black font-medium">{{ row.storename }}</span>
        </template>
      </el-table-column>

      <el-table-column
        label="Store Email"
        min-width="180px"
        prop="storeemail"
        sortable
      >
        <template v-slot="{ row }">
          <span class=" text-black font-medium">{{ row.storeemail }}</span>
        </template>
      </el-table-column>

      <el-table-column label="Rating" min-width="120px" prop="rating" sortable>
        <template v-slot="{ row }">
          <span class=" text-black font-medium">{{ row.rating }}</span>
        </template>
      </el-table-column>

      <el-table-column
        label="Review Count"
        min-width="150px"
        prop="reviewcount"
        sortable
      >
        <template v-slot="{ row }">
          <span class=" text-black font-medium">{{ row.reviewcount }}</span>
        </template>
      </el-table-column>

      <el-table-column
        label="Pending Review"
        min-width="150px"
        prop="pendingreview"
        sortable
      >
        <template v-slot="{ row }">
          <span class=" text-black font-medium">{{ row.pendingreview }}</span>
        </template>
      </el-table-column>
      <el-table-column label="Action" min-width="120px">
        <div class="flex items-center">
          <div
            class="flex items-center mr-4 cursor-pointer"
            data-toggle="tooltip"
            data-placement="top"
            title="View"
          >
            <feather-icon
              @click="ReviewModal = true"
              block
              icon="EyeIcon"
              svgClasses="w-5"
            ></feather-icon>
          </div>
        </div>
      </el-table-column>
    </el-table>

    <b-card-footer class="py-4 d-flex justify-content-end">
      <base-pagination
        v-model="currentPage"
        :per-page="10"
        :total="50"
      ></base-pagination>
    </b-card-footer>
  </b-card>
</template>
<script>
import "../../scss/Index.scss";
import TagsData from "./components/TagsData";
import EditTagsDetail from "./components/EditTagsDetail";
import ReviewTable from "./components/ReviewTable";
import AddTagsSidebar from "./components/AddTagsSidebar";
import {
  Table,
  TableColumn,
  DropdownMenu,
  DropdownItem,
  Dropdown
} from "element-ui";
export default {
  name: "light-table",
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    EditTagsDetail,
    ReviewTable,
    AddTagsSidebar
  },
  data() {
    return {
      TagsData,
      currentPage: 1,
      ReviewModal: false,
      categoryModal: false,
      openAddBannerSidebar: false
    };
  },
  methods: {
    addBanner() {
      this.toggleAddBannerSidebar(true);
    },
    toggleAddBannerSidebar(val = false) {
      this.openAddBannerSidebar = val;
    }
  }
};
</script>
